module.exports = __webpack_public_path__ + "img/advantage6Green.2b281e61.png";